import { useEffect } from "react"
import { useAppDispatch } from "@/core/root-reducer"
import riskStore from "../entities/risk/model/risk.store"

export function useResetRisksSort(filterOverride?: Record<string, any>) {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(riskStore.actions.search({ value: null, columns: ["name"] }))
    dispatch(riskStore.actions.setFilter(filterOverride ?? {}))
    dispatch(riskStore.actions.setSelectedDate(new Date()))
    dispatch(riskStore.actions.sort({ key: "size", asc: false, keySecondary: "riskMax.valueEffective", ascSecondary: false }))
  }, [dispatch])
}
